import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input, Row, Col } from 'reactstrap';
import styled from 'styled-components';

const StyledModalHeader = styled(ModalHeader)`
//   background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 8px 8px 0 0;
  padding: 16px 20px;
  
  .modal-title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 18px;
    font-weight: 600;
    color: #764ba2 ;
  }
  
  .close {
    opacity: 1;
    text-shadow: none;
  }
`;

const IconWrapper = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: white;
  color: #667eea;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
`;

const StyledModalBody = styled(ModalBody)`
  padding: 20px 24px;
`;

const StyledFormGroup = styled(FormGroup)`
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const StyledLabel = styled(Label)`
  font-weight: 600;
  color: #374151;
  font-size: 14px;
  margin-bottom: 0;
  margin-right: 12px;
  min-width: 140px;
  text-align: left;
`;

const StyledInput = styled(Input)`
  background-color: #f9fafb;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 14px;
  color: #6b7280;
  flex: 1;
  
  &:focus {
    background-color: white;
    border-color: #7c3aed;
    box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
  }
  
  &.highlighted {
    background-color: #dbeafe;
    border-color: #3b82f6;
    color: #1e40af;
  }
`;

// const StyledModalFooter = styled(ModalFooter)`
//   padding: 16px 24px;
//   display: flex;
//   justify-content: center;
//   gap: 12px;
//   border-top: 1px solid #e5e7eb;
// `;

// const StyledButton = styled(Button)`
//   border-radius: 8px;
//   padding: 10px 32px;
//   font-weight: 600;
//   font-size: 15px;
//   transition: all 0.2s;
//   min-width: 120px;
  
//   &.btn-primary {
//     background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//     border: none;
//     box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
    
//     &:hover {
//       transform: translateY(-2px);
//       box-shadow: 0 6px 16px rgba(102, 126, 234, 0.5);
//     }
//   }
  
//   &.btn-secondary {
//     background: white;
//     color: #7c3aed;
//     border: 2px solid #7c3aed;
    
//     &:hover {
//       background: #f5f3ff;
//       color: #7c3aed;
//       border-color: #7c3aed;
//     }
//   }
// `;
const StyledModalFooter = styled.div`
  display: flex;
  width: 100%;       /* Ensure it spans the full width of the modal */
  gap: 12px;         /* Adds space between the buttons */
  padding: 16px;     /* Optional: adds padding around the buttons */
`;

const StyledButton = styled(Button)`
flex: 1;           
  padding: 10px;    
  cursor: pointer;
  border-radius: 8px;
  padding: 10px 32px;
  font-weight: 600;
  font-size: 15px;
  transition: all 0.2s;
  min-width: 120px;
  
//   &.btn-primary {
//     background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//     border: none;
//     box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
    
//     &:hover {
//       transform: translateY(-2px);
//       box-shadow: 0 6px 16px rgba(102, 126, 234, 0.5);
//     }
//   }
  
//   &.btn-secondary {
//     background: white;
//     color: #7c3aed;
//     border: 2px solid #7c3aed;
    
//     &:hover {
//       background: #f5f3ff;
//       color: #7c3aed;
//       border-color: #7c3aed;
//     }
//   }
`;

const ConfirmAppointmentModal = ({
  modalIsOpen,
  closeModal,
  submitModal,
  appointmentData,
  onComplete
}) => {
    console.log("ConfirmAppointmentModal", appointmentData)
  const handleConfirm = () => {
    if (submitModal) {
      submitModal();
    }
    if (onComplete) {
      onComplete();
    }
    closeModal();
  };

  return (
    <Modal isOpen={modalIsOpen} toggle={closeModal} size="md">
      <StyledModalHeader toggle={closeModal}>
        <div className="modal-title highlighted">
          Confirm Appointment
        </div>
      </StyledModalHeader>
      
      <StyledModalBody>
        <StyledFormGroup>
          <StyledLabel>RID:</StyledLabel>
          <StyledInput
            type="text"
            value={appointmentData?.rid || 'Not Available'}
            readOnly
            // className="highlighted"
          />
        </StyledFormGroup>

        <StyledFormGroup>
          <StyledLabel>Patient Name:</StyledLabel>
          <StyledInput
            type="text"
            value={appointmentData?.patientName || 'Not Available'}
            readOnly
          />
        </StyledFormGroup>

        <StyledFormGroup>
          <StyledLabel>Patient Age:</StyledLabel>
          <StyledInput
            type="text"
            value={appointmentData?.age || 'Not Available'}
            readOnly
          />
        </StyledFormGroup>

        <StyledFormGroup>
          <StyledLabel>Patient Gender:</StyledLabel>
          <StyledInput
            type="text"
            value={appointmentData?.gender || 'Not Available'}
            readOnly
          />
        </StyledFormGroup>

        <StyledFormGroup>
          <StyledLabel>Partner:</StyledLabel>
          <StyledInput
            type="text"
            value={appointmentData?.partner || 'Not Available'}
            readOnly
          />
        </StyledFormGroup>

        <StyledFormGroup>
          <StyledLabel>Centre:</StyledLabel>
          <StyledInput
            type="text"
            value={appointmentData?.centre || 'Not Available'}
            readOnly
          />
        </StyledFormGroup>

        <StyledFormGroup>
          <StyledLabel>Address:</StyledLabel>
          <StyledInput
            type="text"
            value={appointmentData?.address || 'Not Available'}
            readOnly
          />
        </StyledFormGroup>

        <StyledFormGroup>
          <StyledLabel>Doctor:</StyledLabel>
          <StyledInput
            type="text"
            value={appointmentData?.doctor || 'Not Available'}
            readOnly
          />
        </StyledFormGroup>

        {/* <Row className="gx-4 mb-3">
          <Col md={6}>
            <StyledFormGroup>
              <StyledLabel style={{ minWidth: '50px' }}>Age:</StyledLabel>
              <StyledInput
                type="text"
                value={appointmentData?.age || 'Not Available'}
                readOnly
              />
            </StyledFormGroup>
          </Col>
          <Col md={6}>
            <StyledFormGroup>
              <StyledLabel style={{ minWidth: '60px' }}>Gender:</StyledLabel>
              <StyledInput
                type="text"
                value={appointmentData?.gender || 'Not Available'}
                readOnly
              />
            </StyledFormGroup>
          </Col>
        </Row> */}

        <Row className="gx-4 mb-3">
          <Col md={6}>
            <StyledFormGroup>
              <StyledLabel style={{ minWidth: '50px' }}>Date:</StyledLabel>
              <StyledInput
                type="text"
                value={appointmentData?.appointmentDate || 'Not Available'}
                readOnly
              />
            </StyledFormGroup>
          </Col>
          <Col md={6}>
            <StyledFormGroup>
              <StyledLabel style={{ minWidth: '60px' }}>Time:</StyledLabel>
              <StyledInput
                type="text"
                value={appointmentData?.appointmentTime || 'Not Available'}
                readOnly
              />
            </StyledFormGroup>
          </Col>
        </Row>
      </StyledModalBody>
      
      <StyledModalFooter>
        <StyledButton color="primary" className='highlighted'  onClick={handleConfirm}>
          Confirm
        </StyledButton>
        <StyledButton color="secondary" onClick={closeModal}>
          Close
        </StyledButton>
      </StyledModalFooter>
    </Modal>
  );
};

export default ConfirmAppointmentModal;